// full updated code (starts here)
import React, { useState, useEffect } from "react";
import Select from "react-select";
import classes from './UploadJournal.module.css';
import HeaderNav from '../../Accoungting/HeaderNav/HeaderNav';
import Footer from "../../Accoungting/Footer/Footer";
import { Trash2 } from "lucide-react";
import axios from "axios";
import { BASE_URL } from '../../../Components/Styles/API/API';
import { Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import download from "../../../Assets/download1.svg"
import { useLocation, useNavigate } from "react-router-dom";
import crop from "../../../Assets/repoort.png";
import verified from "../../../Assets/verified.svg";
import RotatingLogo from '../../../Assets/rotating-logo.png';
import { Navbar, Nav, NavDropdown, Button, Modal, Form, Tooltip, Badge, OverlayTrigger } from 'react-bootstrap';


const UploadBalance = () => {
  const token = localStorage.getItem("userToken");
  const navigate = useNavigate();
  const [accounts, setAccounts] = useState([]);
  const [accountsLoading, setAccountsLoading] = useState(false);
  const [reference, setReference] = useState("");
  const [transactionDate, setTransactionDate] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [bearer, setBearer] = useState('');
  const [selectedDate, setSelectedDate] = useState('');
  const [provinceID, setProvinceID] = useState('');
  const [currentMonth, setCurrentMonth] = useState('');
  const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDate] = useState("");
  const [selectedImage, setSelectedImage] = useState('');
  const [balanceLoading, setBalanceLoading] = useState(false);
  const [balances, setBalances] = useState([]);
  const [totalAmountCredit, setTotalAmountCredit] = useState('');
  const [totalAmountDebit, setTotalAmountDebit] = useState('');
  const [isEqual, setIsEqual] = useState(false);
  const [show, setShow] = useState(false);
  const [createLoading, setCreateLoading] = useState('');

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);


  const readData = async () => {
    try {
      const value = localStorage.getItem('userToken');
      const provinceid = localStorage.getItem('provinceID');
      const current = await localStorage.getItem('currentMonth');
      

      if (value !== null) {
        setBearer(value);
      
      }
      if (provinceid !== null) {
        setProvinceID(provinceid);
      }
      if (current !== null) {
        console.log(current);
        const date = new Date(current);
      
        setCurrentMonth(date);
      
        const startOfDateRange = new Date(1900, 0, 1);
     
        const endOfDateRange = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      
        // Format date function as 'YYYY-MM-DD'
        const formatDate = (date) => {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0'); 
          const day = String(date.getDate()).padStart(2, '0');     
          return `${year}-${month}-${day}`;
        };
      
        setMinDate(formatDate(startOfDateRange));
        setMaxDate(formatDate(endOfDateRange));
      }

    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);
  // Fetch accounts for dropdown
  useEffect(() => {
    const fetchAccounts = async () => {
      setAccountsLoading(true);
      try {
        const res = await axios.get(`${BASE_URL}/account`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });
        // Normalize possible response shapes
        const payload = res?.data;
        let raw = payload?.data ?? payload;
        if (raw && typeof raw === 'object' && Array.isArray(raw.data)) {
          raw = raw.data;
        }
        const list = Array.isArray(raw) ? raw : [];
        setAccounts(list);
      } catch (err) {
        setAccounts([]);
      } finally {
        setAccountsLoading(false);
      }
    };
    if (token) fetchAccounts();
  }, [token]);



  const fetchInitialData = async () => {
    const token = localStorage.getItem("userToken");
    try {
      const [refRes, currencyRes] = await Promise.all([
        axios.get(`${BASE_URL}/generate-sales-invoice-code`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }),

      ]); if (refRes?.data?.data) setReference(refRes.data.data.toString());
      if (refRes?.data) {
        const payload = refRes.data;
        const d =
          payload?.data ??
          payload?.code ??
          payload?.reference ??
          payload?.number ??
          payload?.data?.code;
        let ref = "";
        if (typeof d === "string" || typeof d === "number") {
          ref = d;
        } else if (d && typeof d === "object") {
          ref = d.code || d.reference || d.number || "";
        }
        setReference(ref ? String(ref) : "");
      }
    } catch (error) {
      console.error("Error fetching initial data:", error);
    }
  };

  useEffect(() => {
    if (bearer)
      fetchInitialData();
  }, [bearer]);
  useEffect(() => {
    if (token) fetchInitialData();
  }, [token]);

 

    const calculateTotalDebit = () => {
    const total = balances.reduce((acc, item) => {
      return item.debit ? acc + parseFloat(item.debit || 0) : acc;
    }, 0);

    const formattedTotal1 = total.toLocaleString('en-US', {
      minimumIntegerDigits: 1,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    setTotalAmountDebit(formattedTotal1);
  };
  const calculateTotalCredit = () => {
    const total1 = balances.reduce((acc, item) => {
      return item.credit ? acc + parseFloat(item.credit || 0) : acc;
    }, 0);

    const formattedTotal11 = total1.toLocaleString('en-US', {
      minimumIntegerDigits: 1,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    setTotalAmountCredit(formattedTotal11);
  };
  
  useEffect(() => {
    calculateTotalDebit();
    calculateTotalCredit();

  }, [balances]);

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };


  useEffect(() => {
    // Compare the total debit and total credit values
    setIsEqual(totalAmountDebit === totalAmountCredit);
  }, [totalAmountDebit, totalAmountCredit]);

  const postBalances = async () => {
    setBalanceLoading(true);
    const accountNames = balances.map((row) => row.account_name).filter((name) => name !== undefined);
    const accountCodes = balances.map((row) => row.account_code).filter((name) => name !== undefined);
    const debits = balances.map((row) => row.debit).filter((name) => name !== undefined);
    const credits = balances.map((row) => row.credit).filter((name) => name !== undefined);

    console.log(accountNames, accountCodes, debits, credits, totalAmountCredit, totalAmountDebit)
    try {
      //  return;
      const response = await axios.post(
        `${BASE_URL}/account/save-opening-balance`,
        {
          total_debit: totalAmountDebit,
          total_credit: totalAmountCredit,
          uuid: balances[0]?.uuid,
       


        },
        { headers }
      );


      console.log(response.data?.message, "heeee");
      setBalances([]);
      setSelectedDate('');

      Swal.fire({
        icon: 'success',
        title: 'Successful',
        text: response.data.message,
      });

      // toast.success(response.data.message);
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: JSON.stringify(error.response.data.message),
        });
        console.log(error);
      }
    } finally {
      setBalanceLoading(false);
    }
  };

  const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    setSelectedImage(file);
  };

  const uploadStatement = async () => {
    setCreateLoading(true);

    try {

      const formData = new FormData();
      formData.append('file', selectedImage);
      formData.append('transaction_date', selectedDate);


      const response = await axios.post(
        `${BASE_URL}/account/upload-opening-balance`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${bearer}`
          }
        }
      );

      console.log(response, "heeee");
      setBalances(response.data.data);
      handleClose();
      // Reset form fields
      setSelectedImage("");
      Swal.fire({
        icon: 'success',
        title: 'Successful',
        text: response.data.message,
      });
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      if (error.response && error.response.data && error.response.data.message) {
        if (typeof error.response.data.message === 'string') {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join('; ');
        } else if (typeof error.response.data.message === 'object') {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: JSON.stringify(error.response.data.message),
        });
      }
      console.error(error);
    } finally {
      setCreateLoading(false);
    }
  };

  return (
    <div>
      <HeaderNav />

      <Modal 
      show={show} 
      onHide={handleClose} 
      animation={false}>
                                <Modal.Header closeButton>
                                  <Modal.Title>Upload Opening Balance</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                  <Form style={{ marginTop: 20 }}>
                                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                    <div style={{ marginTop: 10 }} />
                                      <Form.Label>Opening Balance as at:</Form.Label>
                                      <Form.Control
                                        type="date"
                                        onChange={handleDateChange}
                                        value={selectedDate}
                                        min={minDate}
                                        max={maxDate}   
                                      />
                                      <div style={{ marginTop: 10 }} />
                                      <Form.Label>File</Form.Label>
                                      <Form.Control
                                        type="file"
                                        placeholder="Choose file"
                                        accept=".xlsx"
                                        onChange={handleImageChange}

                                      />
                                    </Form.Group>
                                  </Form>
                                </Modal.Body>

                                <Modal.Footer>
                                  <Button variant="danger" 
                                  onClick={handleClose}
                                  >
                                    Go back
                                  </Button>
                                  <button 
                                   className={classes.loanBtn}
                                  // variant="success" 
                                  onClick={uploadStatement}
                                  >
                                  Save
                                  </button>
                                </Modal.Footer>
                              </Modal>
                              {createLoading && (
                <div className={classes.overlay}>
                  <img src={RotatingLogo} alt="Loading..." className={classes.rotatingLogo} />
                </div>
                )}
                              {balanceLoading && (
                <div className={classes.overlay}>
                  <img src={RotatingLogo} alt="Loading..." className={classes.rotatingLogo} />
                </div>
                )}


      <div className={classes.Container}>
        <header className={classes.Header}>
          <h2 className={classes.Title}>Upload Opening Balance</h2>
          <div style={{ display: 'flex', justifyContent: "space-between", zIndex: 1 }}>

<div style={{ gap: 10 }} className={classes.flexendtialign}>
  {/* <OverlayTrigger
            placement="top"
            className={classes.btndf1}
            overlay={<Tooltip id="button-tooltip" className={classes.btndf1}>Click here to upload opening balance</Tooltip>}
          > */}
  <button
     className={classes.loanBtn}
    onClick={handleShow}
    >
    Upload
  </button>
 
    <button  className={classes.customButton1} >
                            <a 
                            href={`https://account-api.patna.ng/api/v1/download-opening-balance?province_id=${provinceID}`} 
                            download
                            >
                            <img src={download} alt="download" style={{height: 20, width: 20}}/> Download Template
                              </a>
                          </button>



</div>
</div>
        </header>
       
        <div className={classes.invoicecont}>
          <table className={classes.invoiceTable}>
          <thead style={{ whiteSpace: "nowrap", textAlign: "left", height: "40px" }}>
                                        <tr>
                                          <th >Account Code</th>
                                          <th >Account Name</th>
                                          <th style={{ textAlign: "right", width: "50px", paddingLeft: "10px", paddingRight: "10px" }}>Debit</th>
                                          <th style={{ textAlign: "right", width: "50px", paddingLeft: "10px", paddingRight: "10px" }}>Credit</th>
                                        </tr>
                                      </thead>
          
              
            <tbody style={{}}>
                                        {balances.map((item, index) => (
                                          <tr key={index}>
                                            <td style={{ width: "10px" }}>
                                              {item.gl_code}

                                            </td>
                                            <td>
                                              {item.description}
                                            </td>
                                            <td style={{ textAlign: "right",  paddingLeft: "10px", paddingRight: "10px" }}>{parseFloat(item.debit).toLocaleString('en-US', {
                                              minimumIntegerDigits: 1,
                                              minimumFractionDigits: 2,
                                              maximumFractionDigits: 2
                                            })}
                                            </td>
                                            <td style={{ textAlign: "right",  paddingLeft: "10px", paddingRight: "10px" }}>{parseFloat(item.credit).toLocaleString('en-US', {
                                              minimumIntegerDigits: 1,
                                              minimumFractionDigits: 2,
                                              maximumFractionDigits: 2
                                            })}
                                            </td>
                                          </tr>
                                        ))}
                                      </tbody>


          </table>

          <div style={{ marginTop: 40 }} />
            <div className={classes.form_align}>
                 <Form.Group className="mb-3">
                  <Form.Label>Total Debit:</Form.Label>
                    <Form.Control
                      type="text"
                      value={totalAmountDebit}
                      name="total"
                      readOnly
                      style={{ textAlign: 'right' }}
                      />
                      </Form.Group>
                                <Form.Group className="mb-3">
                                  <Form.Label>Total Credit:</Form.Label>
                                  <Form.Control
                                    type="text"
                                    value={totalAmountCredit}
                                    name="total"
                                    readOnly
                                    style={{ textAlign: 'right' }}
                                  />
                                </Form.Group>
                              </div>


                              <div class={`modal-footer ${classes.overlaybtn100}`} style={{ marginTop: '20px', paddingRight: '20px' }}>
                                <button
                                 className={classes.loanBtn}
                                  // className={classes.longbtn}
                                  onClick={postBalances}
                                  disabled={!isEqual}
                                  style={{ padding: '5px 30px' }}>
                                  Save
                                </button>
                              </div>
          {/* <div className={classes.foot}>
            <div className={classes.Footer}>
              <div className={`${classes.footerSection} ${classes.comments}`}>
                <label>Message</label>
                <textarea className={classes.commentsBox}></textarea>
              </div>

              <div className={`${classes.footerSection} ${classes.summary}`}>
                <div className={classes.grouppp}>
                  <label>Total Debit:</label>
                  <input
                    type="text"
                    value={totalDebit.toLocaleString(undefined, { minimumFractionDigits: 2 })}
                    readOnly
                    className={classes.summaryInput}
                  />
                </div>
                <div className={classes.grouppp}>
                  <label>Total Credit:</label>
                  <input
                    type="text"
                    value={totalCredit.toLocaleString(undefined, { minimumFractionDigits: 2 })}
                    readOnly
                    className={classes.summaryInput}
                  />
                </div>
                <div className={classes.actionButtons}>
                  <button className={classes.cancelButton} type="button" onClick={() => setJournalRows([{
                    account: null,
                    account_id: "",
                    account_code: "",
                    description: "",
                    direction: "",
                    amount: ""
                  }])}>
                    Cancel
                  </button>
                  <button
                    className={classes.saveButton}
                    type="button"
                    onClick={handleSaveJournal}
                    disabled={isSaving}
                  >
                    {isSaving ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          className="me-2"
                        />
                        Saving...
                      </>
                    ) : (
                      "Save"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div> */}
        </div>
        {/* <Footer /> */}
      </div>
    </div>
  );
};

export default UploadBalance;
